export function isDateAfter(left, right) {
  // Ensure first date and second date are valid Date objects
  if (!(left instanceof Date) || !(right instanceof Date)) {
    return false; 
  }

  // Get the time in milliseconds for each date 
  // (this strips off any time-of-day differences)
  const time1 = left.getTime();
  const time2 = right.getTime();

  // Compare the timestamps
  return time1 > time2; 
}
